import { render, staticRenderFns } from "./PendingOrdersIntegrationBackendCmp.vue?vue&type=template&id=2cace891&"
import script from "./PendingOrdersIntegrationBackendCmp.vue?vue&type=script&lang=js&"
export * from "./PendingOrdersIntegrationBackendCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports